var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.row.partner_role_name))]),(!_vm.row.many_partner && _vm.row.is_expire == '1')?_c('tooltip',{staticClass:"expire",attrs:{"label":"跟进已到期","content":"达人已满足自动流转回团队公海，其余商务可认领达人"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }